<div *ngIf="data">
  <app-client-side-data-table
    [id]="tableId"
    [selectFieldName]="'uniqueId'"
    [data]="data"
    [columns]="columns"
    [sort]="sort"
    [eventService]="documentsListEventsService"
    [refreshIt]="refreshDataTable"
  ></app-client-side-data-table>

  @if (isDocsDisclaimer) {
    <p class="docsDisclaimer">{{ 'text.docsDisclaimer' | transloco }}</p>
  }
</div>
